/* eslint-disable tailwindcss/no-custom-classname */
import React from "react";

/*
 * requiredバッヂ
 */
export default function BudgeRequire() {
  return (
    <span className="py-0.5 px-2 ml-2 min-w-[42px] text-[10px] font-bold leading-[18px] text-white rounded md:text-[12px] bg-color-red_error">
      必須
    </span>
  );
}
